// the corredt return type is Record<keyof T, keyof T>, but it doesn't work
export const getKeys = <T extends Record<string, string>>(
  translations: T
): T => {
  const keys: Partial<Record<keyof T, keyof T>> = {}

  Object.keys(translations).forEach((key) => {
    const keyTyped = key as keyof T

    keys[keyTyped] = key
  })

  return keys as T
}
